export enum ValueType {
  NUMBER = 'number' as any,
  BOOLEAN = 'boolean' as any,
  STRING = 'string' as any,
}
